(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["element-header2"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Cart icon: open the theme's own native cart drawer (Horizon's <theme-drawer id="cart-drawer">).
  // If the drawer isn't rendered in this context (e.g. cart_type isn't "drawer", or on the cart page
  // itself), fall back to a normal navigation to the cart page.
  var toggle = document.getElementById('eh-cart-toggle');
  if(toggle){
    toggle.addEventListener('click', function(e){
      var drawer = document.getElementById('cart-drawer');
      if(drawer && typeof drawer.open === 'function'){
        e.preventDefault();
        drawer.open();
      }
      // else: let the link navigate to routes.cart_url normally.
    });
  }

  // Keep our own header badge in sync with the cart count after an add-to-cart
  // elsewhere on the page (see element-product.liquid, which dispatches this).
  document.addEventListener('eh:cart:count', function(e){
    var el = document.getElementById('eh-cart-count');
    if(!el || !e.detail) return;
    el.textContent = e.detail.count;
    el.hidden = e.detail.count === 0;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["element-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var thumb = e.target.closest('.eh-pdp-thumb');
  if(thumb){
    var wrap = thumb.closest('.eh-pdp-thumbs');
    var img = document.getElementById(wrap.getAttribute('data-target'));
    if(img){ img.src = thumb.getAttribute('data-src'); }
    wrap.querySelectorAll('.eh-pdp-thumb').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
});
document.addEventListener('change', function(e){
  var sel = e.target.closest('.eh-pdp-select');
  if(sel){
    var opt = sel.options[sel.selectedIndex];
    var priceEl = document.getElementById(sel.getAttribute('data-price-target'));
    if(priceEl && opt.getAttribute('data-price')){ priceEl.textContent = opt.getAttribute('data-price'); }
  }
});

// AJAX add-to-cart: no page navigation. Refreshes the theme's native cart-drawer
// section (Shopify Section Rendering API) and opens it via the native <theme-drawer>.
document.addEventListener('submit', function(e){
  var form = e.target.closest('.eh-pdp-form');
  if(!form) return;
  e.preventDefault();
  var btn = form.querySelector('.eh-pdp-add');
  var msg = form.querySelector('.eh-pdp-form-msg');
  var original = btn ? (btn.getAttribute('data-add-label') || btn.textContent) : '';
  if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
  if(msg){ msg.textContent = ''; msg.classList.remove('is-error'); }

  var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add.js';
  var fd = new FormData(form);
  // Ask Shopify to also return the rendered HTML for the theme's own cart-drawer
  // section, so its content (line items, subtotal) is genuinely up to date —
  // this is the documented Section Rendering API, not a guess at theme internals.
  fd.append('sections', 'cart-drawer-section');
  fd.append('sections_url', window.location.pathname);

  fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
  .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
  .then(function(res){
    if(!res.ok){
      var m = (res.data && res.data.description) || 'That item could not be added.';
      if(msg){ msg.textContent = m; msg.classList.add('is-error'); }
      return;
    }
    var html = res.data.sections && res.data.sections['cart-drawer-section'];
    var wrap = document.getElementById('shopify-section-cart-drawer-section');
    if(html && wrap){ wrap.innerHTML = html; }

    var drawer = document.getElementById('cart-drawer');
    if(drawer && typeof drawer.open === 'function'){
      drawer.open();
    } else {
      // No drawer in this theme/context (e.g. cart_type isn't "drawer") — fall back to the cart page.
      window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
      return;
    }

    // Let our own header badge know the count changed (see element-header.liquid).
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('eh:cart:count', { detail: { count: cart.item_count } }));
      })
      .catch(function(){});
  })
  .catch(function(){
    if(msg){ msg.textContent = 'Something went wrong. Please try again.'; msg.classList.add('is-error'); }
  })
  .finally(function(){
    if(btn){ btn.disabled = false; btn.textContent = original; }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["element-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var thumb = e.target.closest('.eh-pdp-thumb');
  if(thumb){
    var wrap = thumb.closest('.eh-pdp-thumbs');
    var img = document.getElementById(wrap.getAttribute('data-target'));
    if(img){ img.src = thumb.getAttribute('data-src'); }
    wrap.querySelectorAll('.eh-pdp-thumb').forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }
});
document.addEventListener('change', function(e){
  var sel = e.target.closest('.eh-pdp-select');
  if(sel){
    var opt = sel.options[sel.selectedIndex];
    var priceEl = document.getElementById(sel.getAttribute('data-price-target'));
    if(priceEl && opt.getAttribute('data-price')){ priceEl.textContent = opt.getAttribute('data-price'); }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
